import { useModal } from "../../hooks/use-modal.jsx";
import CandidatAddForm from "../../components/Tenant/Forms/CandidatAddForm";

export default function CandidatAddPage() {
  const [Modal, closeModal] = useModal(true);

  return <CandidatAddForm modal={Modal} onClose={closeModal} />;
}
